import { anyOf, objectOf } from "@altostra/type-validations";
import { nullValidation, string } from "@altostra/type-validations/lib/primitives";

import type { GetDecisioningStudioAgentsAppGroupIdDsaIdFirstRecommendationRunResult } from "./types";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdFirstRecommendationRunResult =
  objectOf<GetDecisioningStudioAgentsAppGroupIdDsaIdFirstRecommendationRunResult>({
    estimated_recommendations_ready_at: anyOf(nullValidation, string),
  });
